














import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { DynamicLinkConfig } from "@/store/types";
import { MetadataLookup, Metadata } from "@/store/metadata/types";
import { FilteredEvent } from "@/store/eventqueue/types";
import LinkedTasksMixin from "@/mixins/LinkedTasksMixin";

const MetadataStore = namespace("metadata");
const EventQueueStore = namespace("eventqueue");

@Component({})
export default class LinkedTaskIcon extends Mixins(LinkedTasksMixin) {
	@Prop() private event: FilteredEvent;

	@MetadataStore.Getter private getMetadataForObject: (lookup: MetadataLookup) => Metadata | Metadata[];
	@EventQueueStore.Mutation private setLinkedTaskModalShown: ({ visible, event, responsesMetadata }) => void;

	/**
	 * Returns true if we have any metadata for any of the responses associated with the event.
	 */
	private get hasMetadataForResponses() {
		return Object.keys(this.responsesMetadata).length > 0;
	}

	/**
	 * Returns a map containing metadata for each response id.
	 */
	private get responsesMetadata(): { [responseId: number]: Metadata[] } {
		if (!this.tasksEnabled || !this.event.responses) {
			return {};
		}

		return this.event.responses.reduce((obj, responseId) => {
			let metadata = this.getMetadataForObject({
				objectId: responseId,
				objectType: "Responses",
				metadataType: "ThirdPartyTaskSystem",
			});

			if (metadata) {
				obj[responseId] = Array.isArray(metadata) ? metadata : [metadata];
			}

			return obj;
		}, {});
	}
}
